<template>
  <div v-if="detail">
    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">负债(未结清)概要</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">未结清信贷交易</div>
        <div class="datacell">账户数</div>
        <div class="datacell">授信额度(万)</div>
        <div class="datacell">余额(万)</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in fzwjq">
        <div class="datacell">{{ item.title }}</div>
        <div class="datacell">{{ item.zhanghu }}</div>
        <div class="datacell">{{ item.edu }}</div>
        <div class="datacell">{{ item.yue }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">合计</div>
        <div class="datacell">{{ fzwjqhj.zhanghu }}</div>
        <div class="datacell">{{ fzwjqhj.edu }}</div>
        <div class="datacell">{{ fzwjqhj.yue }}</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">负债(已结清)概要</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">已结清信贷交易</div>
        <div class="datacell">账户数</div>
        <div class="datacell">授信额度(万)</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in fzyjq">
        <div class="datacell">{{ item.title }}</div>
        <div class="datacell">{{ item.zhanghu }}</div>
        <div class="datacell">{{ item.edu }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">合计</div>
        <div class="datacell">{{ fzyjqhj.zhanghu }}</div>
        <div class="datacell">{{ fzyjqhj.edu }}</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">循环透支(未结清)</div>
    </div>
    <div class="datatable tableinfo2" :key="index" v-for="(item, index) in detail['信贷及授信信息概要_未结清']['循环透支_未结清']">
      <div class="dataitem datahead">
        <div class="sxjg">授信机构：{{ item['授信机构'] }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">开立日期</div>
        <div class="datacell">业务类型</div>
        <div class="datacell">担保方式</div>
        <div class="datacell">发放形式</div>
      </div>
      <div class="dataitem">
        <div class="datacell">{{ item['开立日期'] }}</div>
        <div class="datacell">{{ item['业务种类'] }}</div>
        <div class="datacell">{{ item['担保方式'] }}</div>
        <div class="datacell">{{ item['发放形式'] }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">贷款金额(万)</div>
        <div class="datacell">贷款余额(万)</div>
        <div class="datacell">期限</div>
        <div class="datacell">最近一次还款(万)</div>
      </div>
      <div class="dataitem">
        <div class="datacell">{{ item['信用额度'] }}</div>
        <div class="datacell">{{ item['余额'] }}</div>
        <div class="datacell">{{ item['剩余还款月数'] }}</div>
        <div class="datacell">{{ item['最近一次还款总额'] }}</div>
      </div>
      <div class="dataitem">
        <div class="txtcenter">五级分类：{{ item['五级分类'] }};逾期金额：{{ item['逾期总额'] }}</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">授信协议信息</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">授信机构</div>
        <div class="datacell">生效日</div>
        <div class="datacell">到期日</div>
        <div class="datacell">授信额度(万)</div>
        <div class="datacell">已用额度(万)</div>
        <div class="datacell">授信类型</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail['授信信息_未结清']">
        <div class="datacell">{{ item['授信机构'] }}</div>
        <div class="datacell">{{ item['生效日期'] }}</div>
        <div class="datacell">{{ item['到期日'] }}</div>
        <div class="datacell">{{ item['授信额度'] }}</div>
        <div class="datacell">{{ item['已用额度'] }}</div>
        <div class="datacell">{{ item['授信额度类型'] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object
    },
  },
  watch: {
    detail(newVal) {
      console.log(newVal);

      // #region 负债未结清

      let fzwjq = [];
      let zhanghu = 0;
      let edu = 0;
      let yue = 0;

      if (newVal['信贷及授信信息概要_未结清']) {
        if (newVal['信贷及授信信息概要_未结清']['中长期借款_未结清'].length) {
          newVal['信贷及授信信息概要_未结清']['中长期借款_未结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['信用额度']);
            yue += parseInt(e['余额']);
          })
          fzwjq.push({
            title: "中长期借款",
            zhanghu,
            edu,
            yue,
          })
        }

        if (newVal['信贷及授信信息概要_未结清']['循环透支_未结清'].length) {
          zhanghu = 0;
          edu = 0;
          yue = 0;
          newVal['信贷及授信信息概要_未结清']['循环透支_未结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['信用额度']);
            yue += parseInt(e['余额']);
          })
          fzwjq.push({
            title: "循环透支",
            zhanghu,
            edu,
            yue,
          })
        }
        if (newVal['信贷及授信信息概要_未结清']['短期借款_未结清'].length) {
          zhanghu = 0;
          edu = 0;
          yue = 0;
          newVal['信贷及授信信息概要_未结清']['短期借款_未结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['信用额度']);
            yue += parseInt(e['余额']);
          })
          fzwjq.push({
            title: "短期借款",
            zhanghu,
            edu,
            yue,
          })
        }
        if (newVal['信贷及授信信息概要_未结清']['贴现_未结清'].length) {
          zhanghu = 0;
          edu = 0;
          yue = 0;
          newVal['信贷及授信信息概要_未结清']['贴现_未结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['逾期本金']);
            yue += parseInt(e['余额']);
          })
          fzwjq.push({
            title: "贴现",
            zhanghu,
            edu,
            yue,
          })
        }

        if (newVal['信贷及授信信息概要_未结清']['银行保函及其他业务_未结清'].length) {
          zhanghu = 0;
          edu = 0;
          yue = 0;
          newVal['信贷及授信信息概要_未结清']['银行保函及其他业务_未结清'].forEach(e => {
            zhanghu++;
            edu += 0;
            yue += parseInt(e['余额']);
          })
          fzwjq.push({
            title: "银行保函及其他业务",
            zhanghu,
            edu,
            yue,
          })
        }

        if (newVal['信贷及授信信息概要_未结清']['银行承兑汇票和信用证_未结清'].length) {
          zhanghu = 0;
          edu = 0;
          yue = 0;
          newVal['信贷及授信信息概要_未结清']['银行承兑汇票和信用证_未结清'].forEach(e => {
            zhanghu++;
            edu += 0;
            yue += parseInt(e['余额']);
          })
          fzwjq.push({
            title: "银行承兑汇票和信用证",
            zhanghu,
            edu,
            yue,
          })
        }
      }

      let fzwjqhj = {
        zhanghu: 0,
        edu: 0,
        yue: 0,
      }
      fzwjq.forEach(e => {
        fzwjqhj.zhanghu += e.zhanghu;
        fzwjqhj.edu += e.edu;
        fzwjqhj.yue += e.yue;
      })

      this.fzwjq = fzwjq;
      this.fzwjqhj = fzwjqhj;

      // #endregioin

      // #region 负债未结清

      let fzyjq = [];
      zhanghu = 0;
      edu = 0;

      if (newVal['信贷及授信信息概要_已结清']) {
        if (newVal['信贷及授信信息概要_已结清']['中长期借款_结清'].length) {
          newVal['信贷及授信信息概要_已结清']['中长期借款_结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['借款金额']);
          })
          fzyjq.push({
            title: "中长期借款",
            zhanghu,
            edu,
          })
        }

        if (newVal['信贷及授信信息概要_已结清']['循环透支_结清'].length) {
          zhanghu = 0;
          edu = 0;
          newVal['信贷及授信信息概要_已结清']['循环透支_结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['信用额度']);
          })
          fzyjq.push({
            title: "循环透支",
            zhanghu,
            edu,
          })
        }
        if (newVal['信贷及授信信息概要_已结清']['短期借款_结清'].length) {
          zhanghu = 0;
          edu = 0;
          newVal['信贷及授信信息概要_已结清']['短期借款_结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['借款金额']);
          })
          fzyjq.push({
            title: "短期借款",
            zhanghu,
            edu,
          })
        }
        if (newVal['信贷及授信信息概要_已结清']['贴现_结清'].length) {
          zhanghu = 0;
          edu = 0;
          newVal['信贷及授信信息概要_已结清']['贴现_结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['贴现金额']);
          })
          fzyjq.push({
            title: "贴现",
            zhanghu,
            edu,
          })
        }

        if (newVal['信贷及授信信息概要_已结清']['银行保函及其他业务_结清'].length) {
          zhanghu = 0;
          edu = 0;
          newVal['信贷及授信信息概要_已结清']['银行保函及其他业务_结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['余额']);
          })
          fzyjq.push({
            title: "银行保函及其他业务",
            zhanghu,
            edu,
          })
        }

        if (newVal['信贷及授信信息概要_已结清']['银行承兑汇票和信用证_结清'].length) {
          zhanghu = 0;
          edu = 0;
          yue = 0;
          newVal['信贷及授信信息概要_已结清']['银行承兑汇票和信用证_结清'].forEach(e => {
            zhanghu++;
            edu += parseInt(e['余额']);
          })
          fzyjq.push({
            title: "银行承兑汇票和信用证",
            zhanghu,
            edu,
            yue,
          })
        }
      }

      let fzyjqhj = {
        zhanghu: 0,
        edu: 0,
      }
      fzyjq.forEach(e => {
        fzyjqhj.zhanghu += e.zhanghu;
        fzyjqhj.edu += e.edu;
      })

      this.fzyjq = fzyjq;
      this.fzyjqhj = fzyjqhj;
      // #endregioin

    }
  },
  data() {
    return {
      xhtz: {
        zhanghu: 0,
        edu: 0,
        yue: 0,
      },
      fzwjq: [

      ],
      fzwjqhj: {
        zhanghu: 0,
        edu: 0,
        yue: 0
      },
      fzyjq: [],
      fzyjqhj: {
        zhanghu: 0,
        edu: 0,
      }
    }
  }
}
</script>


<style lang="less" scoped>
.sxjg {
  font-size: .8rem;
  font-weight: bold;
  padding: .6rem;
}

.txtcenter {
  text-align: center !important;
  padding: .6rem;
  font-size: .7rem;
  width: 100%;
}
</style>